import { useState, useEffect } from 'react';

/**
 * A standard hook to check if the component has mounted on the client.
 * Using this prevents hydration mismatches for browser-only APIs like window.
 */
export function useHasMounted() {
  const [hasMounted, setHasMounted] = useState(false);
  
  useEffect(() => {
    setHasMounted(true);
  }, []);
  
  return hasMounted;
}
